const NotFound = () => import("../../components/NotFound.vue");
const OrderListing = () =>
  import("../../components/chemtracker/order_management/OrderListing.vue");
const OrderView = () =>
  import("../../components/chemtracker/order_management/OrderView.vue");
const OrderFireCode = () =>
  import("../../components/chemtracker/order_management/OrderFireCode.vue");

const uuid_pattern =
  "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}";
// Allow a normal node ID so that B4 interface works for fire report.
const node_pattern = uuid_pattern + "|[1-9][0-9]*";

const routes = [
  {
    path: "/raft/chemtracker/order-management",
    component: OrderListing,
  },
  {
    path: "/node/:groupNid(\\d+)/chemtracker/order-management",
    component: OrderListing,
    name: "groupReconciliationHistory",
    props: true,
  },
  {
    path:
      "/raft/chemtracker/:nodeType(order_chemical|order_supplies)/:uuid(" +
      uuid_pattern +
      ")",
    component: OrderView,
    props: true,
  },
  {
    path:
      "/raft/chemtracker/:nodeType(order_chemical)/:uuid(" +
      node_pattern +
      ")/fire-code-report",
    component: OrderFireCode,
    props: true,
  },
  {
    path: "/raft/chemtracker/js/404",
    component: NotFound,
    name: "orderManagementNotFound",
  },
];

const globalComponents = {};

export {
  routes as orderManagementRoutes,
  globalComponents as orderManagementGlobalComponents,
};
